import { HashRouter, BrowserRouter, Route, Routes } from "react-router-dom";
import { Terms } from "./terms/terms";
import { Privacy } from "./terms/privacy";
import { Contact } from "./terms/contact";
import { Banner } from "./Banner";
import { BottomBar } from "./BottomBar";
import DesignEditor from "./DesignEditor";
import { Login } from "./Login";
import Home from "./Home";
import ChoosePlan from "./ChoosePlan";
import { AppDown } from "./AppDown";
import { TokenPage } from "./TokenPage";
import { FreeGenerator } from "./FreeGenerator";
import { NotFound } from "./NotFound";
import { UserProvider } from "./UserProvider";
import DownloadDesign from "./DownloadDesign";
import { Close } from "./Close";
import LinkedInTextGenerator from "./free/LinkedinTextGenerator";
import LinkedInTextFormatter from "./free/LinkedinTextFormatter";
import { FullPost } from "./Fullpost";
import { HowItWorks } from "./HowItWorks";
import { ChangeAudience } from "./ChangeAudience";
import DiscoverySurveyForm from "./DiscoveryForm";
import ChatBox from "./Chat2";
import { SchedulePost } from "./SchedulePost";
import { Settings } from "./Settings";
import InspirationSearch from "./InspirationSearch";
import { ContentCalendarWrapper } from "./ContentCalendarWrapper";
import Calendar from "./TempCalendar";
import CarouselEditor from "./CarouselEditor";

export function PublicRoutes() {
  return (

    <Routes>
      <Route path='/free-certificate-generator' element={<FreeGenerator generatorType='certificate' />} />
      <Route path='/free-linkedin-banner-generator' element={<FreeGenerator generatorType='linkedin-banner' />} />
      <Route path='/linkedin-font-generator' element={<LinkedInTextGenerator />} />
      <Route path='/linkedin-text-formatter' element={<LinkedInTextFormatter />} />
      
    </Routes>
  )
}

export function PrivateRoutes() {
  return (
    <UserProvider>
      <Routes>/
        <Route path="/store-token" element={<Close />} /> 
        <Route path="/settings/extension" element={<Close />} />

        <Route path="/app-down" element={<AppDown />} />
        <Route path="/design/:urlId" element={<DesignEditor />} />
        <Route path="/download/:urlId" element={<DownloadDesign />} />
        <Route path="/" element={<Home />} />
        <Route path="/token" element={<TokenPage />} />
        <Route path="/choose-plan" element={<ChoosePlan />} />
        
        <Route path="/change-audience" element={<ChangeAudience />} />
        <Route path="/discovery-survey" element={<DiscoverySurveyForm />} />
        <Route path="/full-post" element={<FullPost />} />
        <Route path="/chat/:convId" element={<ChatBox />} />
        <Route path="/chat" element={<ChatBox />} />
        <Route path="/settings" element={<Settings />} />
        <Route path='/schedule-post' element={<SchedulePost />} />
        <Route path='/search' element={<InspirationSearch />} />
        <Route path="/content-calendar" element={<ContentCalendarWrapper />} />

        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Login />} />
        <Route path="/how-makemybrand-works" element={<HowItWorks />} />

        <Route path="/carousel-editor" element={<CarouselEditor />} />

        {["terms", "privacy", "contact"].map((p, i) => (
        <Route
          key={i}
          path={"/" + p}
          element={
            <div>
              <Banner />
              <div style={{ padding: "0 20px 20px 20px", marginBottom: 30 }}>
                {p === "terms" && <Terms />}
                {p === "privacy" && <Privacy />}
                {p === "contact" && <Contact />}
              </div>
              <div
                style={{
                  position: "fixed",
                  bottom: 0,
                  width: "100%",
                }}
              >
                <BottomBar />
              </div>
            </div>
          }
        />
      ))}

      </Routes>
    </UserProvider>
  )
}

export function MyRoutes() {
    const isExtension = window.location.protocol === 'chrome-extension:';
    const RouterComponent = isExtension ? HashRouter : BrowserRouter;
    const Router = RouterComponent;
    return (
      <>
      <Router>
        <Routes>
          <Route path="/free-tools/*" element={<PublicRoutes />} />
          
          <Route path="/*" element={<PrivateRoutes />} />   
        </Routes>
      </Router>
     
    </>
  );
}
